import { RateTypeEnum } from '@/api/apply-product/types';

/** 支持购买权益的资方类型列表 */
export const CAN_BUY_RIGHT_RATE_TYPES: RateTypeEnum[] = [
  RateTypeEnum.CAPITAL_TYPE_20,
  RateTypeEnum.CAPITAL_TYPE_24,
];

/** 判断资方类型是否支持购买权益 */
export const isCanBuyRightRateType = (rateType?: RateTypeEnum): boolean => {
  if (!rateType) {
    return false;
  }

  return CAN_BUY_RIGHT_RATE_TYPES.includes(rateType);
};
